/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 23/11/2023 | Lic. José Luis Aragón Cervantes  | Creación
 *      2       | 06/06/2026 | Lic. José Luis Aragón Cervantes  | Ancho compacto de menú secundario
 *      3       | 10/10/2026 | Lic. José Luis Aragón Cervantes  | Dashboard central con planeta y accesos rápidos
 * ---------------------------------------------------------------------------------------
 */
import { Drawer, Hidden } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import { Fragment } from "react";
import SizeSoftXMenu from "./SizeSoftXMenu";
import SizeSoftXDashboardHome from "./SizeSoftXDashboardHome";
import { useConfiguracion } from "../../context/System/ConfiguracionContext";
import { useSesion } from "../../context/System/SesionContext";
import { dashboardPaginas } from "../../settings/menuModel";
import { useLayout } from "../../context/System/LayoutContext";

const SizeSoftXDashboard = () => {
  const { menuClientOpen, menuDashboardOpen, handleCloseMenuClient } = useLayout();
  const { theme } = useConfiguracion();
  const { definicionMenu } = useSesion();
  const drawerMenuWidth = "clamp(210px, 72vw, 240px)";

  return (
    <div className="dashboard-shell">
      <Hidden lgDown>
        {menuDashboardOpen && (
          <aside
            className="menu-area"
            style={{ backgroundColor: theme.palette.kyngblue.main, "--dashboard-menu-width": drawerMenuWidth }}
          >
            <SizeSoftXMenu />
          </aside>
        )}
      </Hidden>

      <Drawer
        open={menuClientOpen}
        anchor="left"
        onClose={handleCloseMenuClient}
        PaperProps={{
          style: {
            backgroundColor: theme.palette.kyngblue.main,
            width: drawerMenuWidth,
          },
        }}
      >
        <div
          className="menu-area"
          style={{
            backgroundColor: theme.palette.kyngblue.main,
            "--dashboard-menu-width": drawerMenuWidth,
          }}
        >
          <SizeSoftXMenu />
        </div>
      </Drawer>

      <div className="dashboard-main">
        <Routes>
          {Object.keys(definicionMenu)
            .filter(
              (clave_modulo) =>
                clave_modulo !== "_paths" && definicionMenu[clave_modulo].mostrar
            )
            .map((clave_modulo) =>
              Object.keys(definicionMenu[clave_modulo]["_paginas"]).map(
                (clave_pagina) => (
                  <Route
                    key={`${clave_modulo}-${clave_pagina}`}
                    path={definicionMenu[clave_modulo]["_paginas"][clave_pagina].path}
                    element={dashboardPaginas[clave_pagina]}
                  />
                )
              )
            )}

          <Route path="/*" element={<SizeSoftXDashboardHome />} />
        </Routes>
      </div>
    </div>
  );
};

export default SizeSoftXDashboard;
